import axios from 'axios';

export default function setAuthToken(accessToken) {
  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
  axios.defaults.headers.common['Content-Type'] = 'application/json';
  axios.defaults.headers.common['accessToken'] = accessToken;
}
